import './style.scss';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import SimpleBar from 'simplebar-react';
import arrowRight from '../../../assets/arrow-right.svg';
import arrowRightBlack from '../../../assets/arrow-right-black.svg';
import imgModel1 from '../../../assets/imgModel3.png';
import imgModel2 from '../../../assets/imgModel4.png';
import ButtonOpt2 from '../../../components/ui/ButtonOpt2';
import {
  resetSideFilled,
  setSelectedTypeModel,
  setTypeModel,
  setTypeModelRemove,
} from '../../../store/reducers/Project/ProjectSlice';
import {
  decrementStep,
  incrementStep,
  setShowSearchModalProduct,
  setShowWarningModalRestart,
} from '../../../store/reducers/User/UserSlice';
import SidePanelFooter from '../SidePanelFooter';
import 'simplebar-react/dist/simplebar.min.css';

const Step1 = ({ totalVal, isLoading }) => {
  const { activeStep, source, typeModel } = useSelector((state) => ({
    activeStep: state.user.activeStep,
    source: state.project.source,
    typeModel: state.project.typeModel,
  }));
  const dispatch = useDispatch();

  const handleNext = useCallback(() => {
    dispatch(incrementStep());
    source?.updEl();
  }, [dispatch, source]);

  const handleBack = useCallback(() => {
    dispatch(decrementStep());
  }, [dispatch]);

  const selectType = useCallback(
    (type) => {
      if (!type) {
        toast.warn('Produkt auswählen');
        return;
      }
      if (typeModel === null) {
        source?.funcSelectType(type);
      } else if (typeModel !== type) {
        source.clearGlobalValues();
        dispatch(resetSideFilled());
        dispatch(setShowWarningModalRestart(true));
      }
      dispatch(setSelectedTypeModel(type));
      dispatch(setTypeModelRemove(type));
      dispatch(setTypeModel(type));
    },
    [dispatch, source, typeModel]
  );

  const handleOpenModal = useCallback(() => {
    dispatch(setShowSearchModalProduct(true));
  }, [dispatch]);

  const modelChoices = useMemo(
    () => [
      {
        id: 'louver',
        image: imgModel1,
        title: 'Lamellendach',
        active: typeModel === 'louver',
      },
      {
        id: 'glass',
        image: imgModel2,
        title: 'Glasdach',
        active: typeModel === 'glass',
      },
    ],
    [typeModel]
  );

  return (
    <>
      <div className="step1">
        <SimpleBar style={{ maxHeight: '100%', width: '100%' }}>
          <div className="step1__content">
            <div className="step1__text">
              Wenn Sie wissen welcher Dachtyp Sie wünschen, dann wählen Sie
              unten aus. Falls Sie nicht wissen was für Sie passt können Sie den
              Produktefinder verwenden um die ideale Überdachungslösung zu
              finden.
            </div>
            <div className="step1__line">
              <span> </span>
            </div>

            <ButtonOpt2
              icon={arrowRight}
              text="Produktfinder"
              handleClick={handleOpenModal}
            />
            {modelChoices.map(({ id, image, title, active }) => (
              <button
                key={id}
                type="button"
                className={`step1__content-choiceModel ${
                  active ? 'choiceModelActive' : ''
                }`}
                onClick={() => selectType(id)}
              >
                <img
                  className="step1__content-choiceModel-image"
                  src={image}
                  alt={title}
                />
                <div>
                  {title}
                  <img src={arrowRightBlack} alt="arrowRightBlack" />
                </div>
              </button>
            ))}
          </div>
        </SimpleBar>
      </div>
      <SidePanelFooter
        isLoading={isLoading}
        totalVal={totalVal}
        handleNext={handleNext}
        handleBack={handleBack}
        activeStep={activeStep}
        disableBtn={typeModel === null}
      />
    </>
  );
};

export default Step1;
